import {useParams} from 'react-router-dom';
import {CaregiverMode} from '../../../../../../enums/caregiver-mode';
import {ActivityTimeline} from '../../../../../../components/activity-timeline/activity-timeline';
import {translations} from '../../../../../../i18n/translations';
import {ScreenPaths} from '../../../../../../enums';
import {useAuth} from '../../../../../../contexts/auth/context';
import {useTranslation} from 'react-i18next';

export default function ActivityProfessionalCaregiverOfficeScreen() {
  let {entityId}: {entityId?: string} = useParams();
  const authContext = useAuth();
  const {t} = useTranslation();

  return (
    <ActivityTimeline
      headerTitleCrumbs={[
        {
          label: t(translations.dashboard_side_menu.dashboard),
          link: `/office${ScreenPaths.Office_ProfessionalCaregiver}/${authContext.state.session?.selectedAffiliation?.entity.id}${ScreenPaths.ProfessionalCaregiver_Dashboard}`,
        },
        {
          label: t(translations.dashboard_side_menu.general_activity),
          link: `/office${ScreenPaths.Office_ProfessionalCaregiver}/${authContext.state.session?.selectedAffiliation?.entity.id}${ScreenPaths.ProfessionalCaregiver_Dashboard}`,
        },
      ]}
      caregiverMode={CaregiverMode.Professional}
      entityId={entityId}
    />
  );
}
